import script from "./Construction.vue?vue&type=script&setup=true&lang=js"
export * from "./Construction.vue?vue&type=script&setup=true&lang=js"

import "./Construction.vue?vue&type=style&index=0&id=069e2801&lang=scss&scoped=true"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-069e2801"]])

export default __exports__